export type SortDirection = "asc" | "desc";

export function sortTaxonomyByLabel<T extends { label: string }>(
  items: readonly T[],
  direction: SortDirection = "asc",
): T[] {
  return [...items].sort((a, b) => {
    const cmp = a.label.localeCompare(b.label, "fr");
    return direction === "asc" ? cmp : -cmp;
  });
}

export function sortTaxonomyBySlug<T extends { slug: string }>(
  items: readonly T[],
  direction: SortDirection = "asc",
): T[] {
  return [...items].sort((a, b) => {
    const cmp = a.slug.localeCompare(b.slug);
    return direction === "asc" ? cmp : -cmp;
  });
}
